import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "flex-container" }
const _hoisted_4 = { class: "image-container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-container" }
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "about-project" }
const _hoisted_9 = { class: "content-grid" }
const _hoisted_10 = { class: "text-block" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "architecture-details" }
const _hoisted_14 = { class: "architecture-visual" }
const _hoisted_15 = { class: "visual-header" }
const _hoisted_16 = { class: "visual-caption" }
const _hoisted_17 = { class: "architecture-visual docker-visual" }
const _hoisted_18 = { class: "visual-header" }
const _hoisted_19 = { class: "visual-caption" }
const _hoisted_20 = { class: "tech-grid" }
const _hoisted_21 = { class: "tech-card" }
const _hoisted_22 = { class: "tech-text" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "tech-card" }
const _hoisted_26 = { class: "tech-text" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "code-peek" }
const _hoisted_30 = { class: "code-intro" }
const _hoisted_31 = { class: "code-container" }
const _hoisted_32 = { class: "code-header" }
const _hoisted_33 = { class: "file-path" }
const _hoisted_34 = { class: "code-container second-code" }
const _hoisted_35 = { class: "code-header" }
const _hoisted_36 = { class: "file-path" }
const _hoisted_37 = { class: "interfaces" }
const _hoisted_38 = { class: "interface-grid" }
const _hoisted_39 = { class: "interface-block" }
const _hoisted_40 = { class: "image-wrapper" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "interface-block" }
const _hoisted_43 = { class: "double-image-wrapper" }
const _hoisted_44 = ["src"]
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "technical-details" }
const _hoisted_47 = { class: "competencies-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfraCompetencyCard = _resolveComponent("InfraCompetencyCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/image/referendum-logo.png'),
            alt: "Logo Referendum",
            class: "header-image",
            loading: "lazy"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t('referendum.title')), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('referendum.subtitle')), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('referendum.aboutTitle')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('referendum.about1')
          }, null, 8, _hoisted_11),
          _createElementVNode("p", {
            innerHTML: _ctx.$t('referendum.about2')
          }, null, 8, _hoisted_12),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('referendum.about3')), 1)
        ]),
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"highlight-box\" data-v-508f4b4c><div class=\"stat-item\" data-v-508f4b4c><span class=\"mdi mdi-shield-lock-outline stat-icon\" data-v-508f4b4c></span><span class=\"stat-text\" data-v-508f4b4c>ElGamal Encryption</span></div><div class=\"stat-item\" data-v-508f4b4c><span class=\"mdi mdi-lan-connect stat-icon\" data-v-508f4b4c></span><span class=\"stat-text\" data-v-508f4b4c>TLS Secured Sockets</span></div><div class=\"stat-item\" data-v-508f4b4c><span class=\"mdi mdi-file-tree-outline stat-icon\" data-v-508f4b4c></span><span class=\"stat-text\" data-v-508f4b4c>Modular Gradle Monolith</span></div></div>", 1))
      ])
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('referendum.techTitle')), 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "visual-badge" }, "System Workflow", -1)),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('referendum.techWorkflow')), 1)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "mermaid-container",
          id: "voting-diagram"
        }, null, -1)),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('referendum.techCaption')), 1)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "visual-badge" }, "Deployment Blueprint", -1)),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('referendum.dockerTitle')), 1)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "mermaid-container",
          id: "docker-diagram"
        }, null, -1)),
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('referendum.dockerCaption')), 1)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mdi mdi-swap-horizontal tech-icon" }, null, -1)),
          _createElementVNode("div", _hoisted_22, [
            _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Sockets & Sprints", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                innerHTML: _ctx.$t('referendum.tech1')
              }, null, 8, _hoisted_23),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('referendum.tech4')
              }, null, 8, _hoisted_24)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "mdi mdi-security tech-icon" }, null, -1)),
          _createElementVNode("div", _hoisted_26, [
            _cache[7] || (_cache[7] = _createElementVNode("h4", null, "Sécurité Avancée", -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                innerHTML: _ctx.$t('referendum.tech2')
              }, null, 8, _hoisted_27),
              _createElementVNode("li", {
                innerHTML: _ctx.$t('referendum.tech3')
              }, null, 8, _hoisted_28)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_29, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('referendum.codeTitle')), 1),
      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('referendum.codeCaption')), 1),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "dots" }, [
            _createElementVNode("span", { class: "dot red" }),
            _createElementVNode("span", { class: "dot yellow" }),
            _createElementVNode("span", { class: "dot green" })
          ], -1)),
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('referendum.codeFile1')), 1)
        ]),
        _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"code-content\" data-v-508f4b4c><pre data-v-508f4b4c><code data-v-508f4b4c><span class=\"k\" data-v-508f4b4c>public class</span> <span class=\"c\" data-v-508f4b4c>DecryptCryptoServiceImpl</span> <span class=\"k\" data-v-508f4b4c>implements</span> <span class=\"c\" data-v-508f4b4c>DecryptCryptoService</span> {\n    <span class=\"k\" data-v-508f4b4c>@Override</span>\n    <span class=\"k\" data-v-508f4b4c>public</span> <span class=\"c\" data-v-508f4b4c>ResultatDecryptModel</span> <span class=\"f\" data-v-508f4b4c>decryt</span>(<span class=\"c\" data-v-508f4b4c>ChiffrerDecryptModel</span> chiffrer, <span class=\"c\" data-v-508f4b4c>List</span>&lt;<span class=\"c\" data-v-508f4b4c>BigInteger</span>&gt; prepares, <span class=\"c\" data-v-508f4b4c>BigInteger</span> p, <span class=\"c\" data-v-508f4b4c>BigInteger</span> g) {\n        <span class=\"c\" data-v-508f4b4c>BigInteger</span> prepare = <span class=\"c\" data-v-508f4b4c>BigInteger</span>.<span class=\"c\" data-v-508f4b4c>ONE</span>;\n        <span class=\"k\" data-v-508f4b4c>for</span> (<span class=\"c\" data-v-508f4b4c>BigInteger</span> i : prepares) {\n            prepare = prepare.<span class=\"f\" data-v-508f4b4c>multiply</span>(i);\n        }\n\n        <span class=\"c\" data-v-508f4b4c>BigInteger</span> gPowSommeVi = chiffrer.<span class=\"f\" data-v-508f4b4c>getV</span>().<span class=\"f\" data-v-508f4b4c>multiply</span>(prepare.<span class=\"f\" data-v-508f4b4c>modInverse</span>(p)).<span class=\"f\" data-v-508f4b4c>mod</span>(p);\n        <span class=\"c\" data-v-508f4b4c>BigInteger</span> MTest;\n        <span class=\"c\" data-v-508f4b4c>BigInteger</span> B = <span class=\"c\" data-v-508f4b4c>BigInteger</span>.<span class=\"c\" data-v-508f4b4c>TWO</span>.<span class=\"f\" data-v-508f4b4c>pow</span>(chiffrer.<span class=\"f\" data-v-508f4b4c>getNbVotes</span>()).<span class=\"f\" data-v-508f4b4c>subtract</span>(<span class=\"c\" data-v-508f4b4c>BigInteger</span>.<span class=\"c\" data-v-508f4b4c>ONE</span>);\n        <span class=\"k\" data-v-508f4b4c>for</span> (<span class=\"c\" data-v-508f4b4c>BigInteger</span> i = <span class=\"c\" data-v-508f4b4c>BigInteger</span>.<span class=\"c\" data-v-508f4b4c>ZERO</span>; i.<span class=\"f\" data-v-508f4b4c>compareTo</span>(B) &lt;= <span class=\"s\" data-v-508f4b4c>0</span>; i = i.<span class=\"f\" data-v-508f4b4c>add</span>(<span class=\"c\" data-v-508f4b4c>BigInteger</span>.<span class=\"c\" data-v-508f4b4c>ONE</span>)) {\n            MTest = g.<span class=\"f\" data-v-508f4b4c>modPow</span>(i, p);\n            <span class=\"k\" data-v-508f4b4c>if</span> (MTest.<span class=\"f\" data-v-508f4b4c>equals</span>(gPowSommeVi)) {\n                <span class=\"k\" data-v-508f4b4c>return new</span> <span class=\"c\" data-v-508f4b4c>ResultatDecryptModel</span>(i.<span class=\"f\" data-v-508f4b4c>intValue</span>(), chiffrer.<span class=\"f\" data-v-508f4b4c>getNbVotes</span>() - i.<span class=\"f\" data-v-508f4b4c>intValue</span>());\n            }\n        }\n        <span class=\"k\" data-v-508f4b4c>throw new</span> <span class=\"c\" data-v-508f4b4c>RuntimeException</span>(<span class=\"s\" data-v-508f4b4c>&quot;No solution found&quot;</span>);\n    }\n}</code></pre></div>", 1))
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "dots" }, [
            _createElementVNode("span", { class: "dot red" }),
            _createElementVNode("span", { class: "dot yellow" }),
            _createElementVNode("span", { class: "dot green" })
          ], -1)),
          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('referendum.codeFile2')), 1)
        ]),
        _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"code-content\" data-v-508f4b4c><pre data-v-508f4b4c><code data-v-508f4b4c><span class=\"k\" data-v-508f4b4c>@Override</span>\n<span class=\"k\" data-v-508f4b4c>public void</span> <span class=\"f\" data-v-508f4b4c>aNewDecrypt</span>(<span class=\"c\" data-v-508f4b4c>UUID</span> referendumId, <span class=\"c\" data-v-508f4b4c>UUID</span> questionId, <span class=\"c\" data-v-508f4b4c>PrepareDto</span> prepare, <span class=\"c\" data-v-508f4b4c>UUID</span> userId) {\n    <span class=\"c\" data-v-508f4b4c>LocalDateTime</span> now = <span class=\"c\" data-v-508f4b4c>LocalDateTime</span>.<span class=\"f\" data-v-508f4b4c>now</span>(<span class=\"c\" data-v-508f4b4c>ZoneOffset</span>.<span class=\"f\" data-v-508f4b4c>ofHours</span>(<span class=\"s\" data-v-508f4b4c>2</span>));\n    <span class=\"c\" data-v-508f4b4c>ReferendumModel</span> referendumModel = referendumService.<span class=\"f\" data-v-508f4b4c>findReferendumByIdStarted</span>(referendumId);\n    \n    <span class=\"k\" data-v-508f4b4c>if</span> (referendumModel.<span class=\"f\" data-v-508f4b4c>getEndDate</span>().<span class=\"f\" data-v-508f4b4c>isAfter</span>(now)) {\n        <span class=\"k\" data-v-508f4b4c>throw new</span> <span class=\"c\" data-v-508f4b4c>IllegalArgumentException</span>(<span class=\"s\" data-v-508f4b4c>&quot;Le referendum n&#39;est pas terminé&quot;</span>);\n    }\n    \n    <span class=\"t\" data-v-508f4b4c>// ... Validation et stockage de la part de déchiffrement</span>\n    decryptRepository.<span class=\"f\" data-v-508f4b4c>insertPrepare</span>(chiffrerId, pkId, <span class=\"k\" data-v-508f4b4c>new</span> <span class=\"c\" data-v-508f4b4c>BigInteger</span>(prepare.<span class=\"f\" data-v-508f4b4c>getPrepare</span>()));\n    \n    <span class=\"t\" data-v-508f4b4c>// Si tous les scrutateurs ont envoyé leur part</span>\n    <span class=\"k\" data-v-508f4b4c>if</span> (decryptRepository.<span class=\"f\" data-v-508f4b4c>nbPrepared</span>(chiffrerId) == referendumModel.<span class=\"f\" data-v-508f4b4c>getPk_ids</span>().<span class=\"f\" data-v-508f4b4c>size</span>()) {\n        <span class=\"c\" data-v-508f4b4c>ResultatDecryptModel</span> result = decryptCryptoService.<span class=\"f\" data-v-508f4b4c>decryt</span>(chiffrerDecryptModel, prepares, p, g);\n        resultatService.<span class=\"f\" data-v-508f4b4c>insertResultat</span>(questionId, result);\n    }\n}</code></pre></div>", 1))
      ])
    ]),
    _createElementVNode("section", _hoisted_37, [
      _cache[13] || (_cache[13] = _createElementVNode("h2", null, "Interfaces & Expérience", -1)),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('referendum.adminTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('referendum.adminIntro')), 1),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("img", {
              src: require('@/assets/image/admin-user-panel.png'),
              alt: "Panneau d'administration",
              class: "doc-image",
              loading: "lazy"
            }, null, 8, _hoisted_41)
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('referendum.userTitle')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('referendum.userIntro')), 1),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("img", {
              src: require('@/assets/image/referendum-view.png'),
              alt: "Referendum view",
              class: "doc-image small",
              loading: "lazy"
            }, null, 8, _hoisted_44),
            _createElementVNode("img", {
              src: require('@/assets/image/scrutateur-view.png'),
              alt: "Scrutateur view",
              class: "doc-image small",
              loading: "lazy"
            }, null, 8, _hoisted_45)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_46, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('referendum.learningsTitle')), 1),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-shield-key-outline",
          title: "Cryptographie & Sécurité",
          description: _ctx.$t('referendum.learning1')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-application-cog-outline",
          title: "Architecture Logicielle",
          description: _ctx.$t('referendum.learning2')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-git",
          title: "Gestion de Projet Agile",
          description: _ctx.$t('referendum.learning3')
        }, null, 8, ["description"]),
        _createVNode(_component_InfraCompetencyCard, {
          icon: "mdi-lan-connect",
          title: "Communication Réseau",
          description: _ctx.$t('referendum.learning4')
        }, null, 8, ["description"])
      ])
    ])
  ]))
}